var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contract-quotation-info-container" }, [
    _c("div", { staticClass: "info-section" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "quotation-list",
        },
        [
          !_vm.quotationData || _vm.quotationData.length === 0
            ? _c("el-empty", { attrs: { description: "暂无报价信息" } })
            : _c(
                "div",
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "center",
                        "margin-bottom": "8px",
                      },
                    },
                    [_c("div"), _vm._v(" "), _c("div")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      ref: "quotationTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.quotationData,
                        border: "",
                        size: "small",
                      },
                      on: { "row-click": _vm.handleRowClick },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "expand", width: "40" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "expand-table-container" },
                                  [
                                    _c(
                                      "el-table",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          data: props.row.quotes,
                                          border: "",
                                          size: "small",
                                        },
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "priceType",
                                            label: "计价分类",
                                            width: "100",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "name",
                                            label: "名称",
                                            width: "100",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "material",
                                            label: "基材",
                                            width: "120",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "color",
                                            label: "颜色",
                                            width: "100",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "priceRule",
                                            label: "计价规则",
                                            "min-width": "150",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "minVol",
                                            label: "最小计价量",
                                            width: "100",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          scope.row.minVol !==
                                                            undefined
                                                            ? scope.row.minVol
                                                            : "-"
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "volume",
                                            label: "计价量",
                                            width: "80",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          scope.row.volume !==
                                                            undefined
                                                            ? scope.row.volume
                                                            : "-"
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "unitPrice",
                                            label: "单价",
                                            width: "80",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          scope.row.unitPrice
                                                            ? scope.row.unitPrice.toFixed(
                                                                2
                                                              )
                                                            : "-"
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "addRules",
                                            label: "加收规则",
                                            width: "120",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          scope.row.addRules ||
                                                            "-"
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "addUnitPrice",
                                            label: "加收单价",
                                            width: "80",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          scope.row
                                                            .addUnitPrice !==
                                                            undefined
                                                            ? scope.row.addUnitPrice.toFixed(
                                                                2
                                                              )
                                                            : "-"
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "addPrice",
                                            label: "加收金额",
                                            width: "80",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          scope.row.addPrice !==
                                                            undefined
                                                            ? scope.row.addPrice.toFixed(
                                                                2
                                                              )
                                                            : "-"
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "addRatio",
                                            label: "加收比例",
                                            width: "80",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          scope.row.addRatio !==
                                                            undefined
                                                            ? scope.row
                                                                .addRatio + "%"
                                                            : "-"
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "totalAmount",
                                            label: "合计",
                                            width: "100",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _vm._v(
                                                      "\n                      ¥" +
                                                        _vm._s(
                                                          (
                                                            scope.row
                                                              .totalAmount || 0
                                                          ).toFixed(2)
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "quote-summary" },
                                      [
                                        _c("div"),
                                        _vm._v(" "),
                                        _c("div", [
                                          _c("span", [_vm._v("小计：")]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "total-amount" },
                                            [
                                              _vm._v(
                                                "¥" +
                                                  _vm._s(
                                                    _vm
                                                      .getQuoteTotal(
                                                        props.row.quotes
                                                      )
                                                      .toFixed(2)
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "productionOrder",
                          label: "订单号",
                          "min-width": "180",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "auditName",
                          label: "产品名称",
                          "min-width": "150",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "productionStatus",
                          label: "订单状态",
                          width: "100",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "报价小计", width: "120" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", { staticClass: "total-amount" }, [
                                  _vm._v(
                                    "¥" +
                                      _vm._s(
                                        _vm
                                          .getQuoteTotal(scope.row.quotes)
                                          .toFixed(2)
                                      )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "orderClerkTime",
                          label: "下单时间",
                          "min-width": "180",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "flex-end",
                        padding: "10px 20px",
                        background: "#f5f7fa",
                        border: "1px solid #ebeef5",
                        "border-top": "none",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "14px",
                            "font-weight": "bold",
                          },
                        },
                        [
                          _vm._v("\n            合计："),
                          _c(
                            "span",
                            {
                              staticClass: "total-amount",
                              staticStyle: { "font-size": "16px" },
                            },
                            [
                              _vm._v(
                                "¥" + _vm._s(_vm.getGrandTotal().toFixed(2))
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }